function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { env } from '@ui/environment';
import { CerbosLogger } from './cerbos.logger';
const logger = new CerbosLogger('Decision', env.PUBLIC_USE_SENTRY);
let cerbosEnginePromise = null;
async function getCerbosEngine() {
    if (!cerbosEnginePromise) {
        cerbosEnginePromise = import('./cerbos-embedded-engine').then((param)=>{
            let { cerbosEngine } = param;
            return cerbosEngine;
        });
    }
    return cerbosEnginePromise;
}
export const getDecision = async (param)=>{
    let { principal, resource, actions } = param;
    const cerbosEngine = await getCerbosEngine();
    cerbosEngine.initialize();
    const results = {};
    const promises = actions.map(async (action)=>{
        try {
            var _principal_attributes, _resource_attributes;
            const allowed = await cerbosEngine.isAllowed({
                principal: {
                    id: principal.id,
                    roles: principal.roles,
                    attributes: (_principal_attributes = principal.attributes) !== null && _principal_attributes !== void 0 ? _principal_attributes : {}
                },
                resource: {
                    kind: resource.kind,
                    id: resource.id,
                    attributes: (_resource_attributes = resource.attributes) !== null && _resource_attributes !== void 0 ? _resource_attributes : {}
                },
                action
            });
            return {
                action,
                allowed
            };
        } catch (e) {
            var _resource_attributes1;
            const error = e;
            logger.error({
                message: 'Error checking permission',
                error,
                request: {
                    principal: {
                        id: principal.id,
                        roles: principal.roles
                    },
                    resource: {
                        kind: resource.kind,
                        id: resource.id,
                        attr: (_resource_attributes1 = resource.attributes) !== null && _resource_attributes1 !== void 0 ? _resource_attributes1 : {}
                    },
                    action
                }
            });
            return {
                action,
                allowed: false
            };
        }
    });
    const resolvedResults = await Promise.all(promises);
    resolvedResults.forEach((param)=>{
        let { action, allowed } = param;
        results[action] = allowed;
    });
    return {
        isAllowed: (action)=>{
            var _results_action;
            return (_results_action = results[action]) !== null && _results_action !== void 0 ? _results_action : false;
        },
        getAllowedActions: ()=>Object.keys(results).filter((action)=>results[action]),
        getDeniedActions: ()=>Object.keys(results).filter((action)=>!results[action]),
        getResults: ()=>_object_spread({}, results)
    };
};
